<template>
  <div style="font-size: 15px; border: 1px solid #E0E0E0;border-radius: 8px;padding:12px 18px">
    <div style="grid-template-columns: repeat(12, minmax(0, 1fr));display: grid; gap: 13px;">
      <div style="grid-column: span 5 / span 5;">
        <span class="font-weight-bold">Ngày chuyển: {{ transferFeeDetail.createdAt ? moment(transferFeeDetail.createdAt).format('DD-MM-YYYY') : '' }}</span>
      </div>
      <div  style="grid-column: span 2 / span 2;text-align: center">
        <span v-if="!isConfirm">Mã ticket:
          <v-tooltip bottom>
            <template v-slot:activator="{on, attrs}">
              <span class="font-weight-medium" v-on="on" v-bind="attrs" @click="handleShowDetail" style="text-decoration: underline; color: blue; cursor: pointer">{{ checkEmptyData(transferFeeDetail.ticketCode) }}</span>
            </template>
            <span>Xem chi tiết chuyển phí</span>
          </v-tooltip>
        </span>
      </div>
      <div style="grid-column: span 5 / span 5; text-align: right">
        <span class="font-weight-bold">Người thực hiện: {{transferFeeDetail.createdBy ? checkEmptyData(transferFeeDetail.createdBy.name) : '' }}</span>
      </div>
    </div>

    <div style="grid-template-columns: repeat(13, minmax(0, 1fr));display: grid; gap: 13px;" class="mt-5">
      <!-- Old Package -->

      <div style="grid-column: span 6 / span 6;">
        <div class="package-section">
          <div class="font-weight-bold mb-2">GÓI CŨ</div>
          <div class="mb-3">
            Học viên :
            <strong>
              {{transferFeeDetail.oldStudentProduct ? checkEmptyData(transferFeeDetail.oldStudentProduct.studentName) : ''}}
            </strong>
            (<span> UID: <strong>{{transferFeeDetail.oldStudentProduct ? checkEmptyData(transferFeeDetail.oldStudentProduct.lmsCoreUserId ) : '' }}</strong></span>
            - <span > SID: <strong>{{transferFeeDetail.oldStudentProduct ? checkEmptyData(transferFeeDetail.oldStudentProduct.studentId ) : '' }}</strong></span> )
          </div>
          <div class="mb-3">
            Gói : <strong>{{ checkEmptyData(transferFeeDetail.oldPackageInfo.packageName) }}</strong>
          </div>
          <div class="mb-3 d-flex align-center">
            <div style="margin-right: 3px">
              Lộ trình :
            </div>
            <strong>
              <template v-if="transferFeeDetail.oldPackageInfo.programGroup">
                <v-tooltip top color="#FFF" max-width="350px" content-class="content-tooltip-transfer">
                  <template v-slot:activator="{ on,attrs }">
                    <div v-on="on" v-bind="attrs">
                    <span v-for="(program, key) in transferFeeDetail.oldPackageInfo.programGroup" :key="program.id+ 'programGroup'" style="cursor: pointer; font-size: 14px !important;">
                      {{ program.id }} <span v-if="key < transferFeeDetail.oldPackageInfo.programGroup.length -1 ">; </span>
                    </span>
                    </div>
                  </template>
                  <div  style="color: #000 !important;">
                    <div v-for="(program) in transferFeeDetail.oldPackageInfo.programGroup"  :key="program.id+ 'programGroupName'">
                      {{ program.title }}
                      <br>
                    </div>
                  </div>
                </v-tooltip>
              </template>
            </strong>
          </div>
          <div class="mb-3">
            Tổng số buổi : {{ checkEmptyData(transferFeeDetail.oldPackageInfo.numberLesson.totalLessons) }} /
            Số buổi chính : {{  checkEmptyData(transferFeeDetail.oldPackageInfo.numberLesson.mainLessons) }}
          </div>
          <div class="mb-3">
            Tổng số buổi đã học : {{ checkEmptyData(transferFeeDetail.oldPackageInfo.numberLessonFeeReceived.totalLessons) }} /
            Số buổi chính đã học : {{  checkEmptyData(transferFeeDetail.oldPackageInfo.numberLessonFeeReceived.mainLessons) }}
          </div>
          <div class="mb-3">
            Số buổi được chuyển phí : <strong>{{  checkEmptyData(transferFeeDetail.oldPackageInfo.numberLessonTransfer) }} buổi </strong>
          </div>
        </div>
      </div>

      <div style="grid-column: span 1 / span 1;" class="d-flex align-center justify-center position-relative">
        <div class="transfer-divider">
          <div class="circle-arrow">
            <v-icon color="white" size="22">mdi-arrow-right</v-icon>
          </div>
          <div class="dashed-line"></div>
        </div>
      </div>

      <div style="grid-column: span 6 / span 6;">
        <div class="package-section">
          <div class="font-weight-bold mb-2">GÓI MỚI</div>
          <div class="mb-3">
            Học viên nhận phí :
            <template v-if="transferFeeDetail.paymentMethod.id === PAYMENT_METHOD.NGANG_TIEN">
              <strong>
                {{transferFeeDetail.newStudentProduct ? checkEmptyData(transferFeeDetail.newStudentProduct.studentName) : ''}}
              </strong>
              (<span> UID: <strong>{{transferFeeDetail.newStudentProduct ? checkEmptyData(transferFeeDetail.newStudentProduct.lmsCoreUserId ) : '' }}</strong></span>
              - <span > SID: <strong>{{transferFeeDetail.newStudentProduct ? checkEmptyData(transferFeeDetail.newStudentProduct.studentId ) : '' }}</strong></span> )
            </template>
            <template v-else-if="transferFeeDetail.paymentMethod.id === PAYMENT_METHOD.THANH_TOAN_THEM">
              <strong>
                {{transferFeeDetail.oldStudentProduct ? checkEmptyData(transferFeeDetail.oldStudentProduct.studentName) : ''}}
              </strong>
              (<span> UID: <strong>{{transferFeeDetail.oldStudentProduct ? checkEmptyData(transferFeeDetail.oldStudentProduct.lmsCoreUserId ) : '' }}</strong></span>
              - <span > SID: <strong>{{transferFeeDetail.oldStudentProduct ? checkEmptyData(transferFeeDetail.oldStudentProduct.studentId ) : '' }}</strong></span> )
            </template>
          </div>
          <div class="mb-3" v-if="transferFeeDetail.paymentMethod.id === PAYMENT_METHOD.NGANG_TIEN">
            Gói : <strong>{{ checkEmptyData(transferFeeDetail.newPackageInfo.packageName) }}
          </strong>
          </div>
          <div class="mb-3 d-flex align-center" v-if="transferFeeDetail.paymentMethod.id === PAYMENT_METHOD.NGANG_TIEN">
            <div style="margin-right: 3px">
              Lộ trình :
            </div>
            <strong>
              <template v-if="transferFeeDetail.newPackageInfo.programGroup">
                <v-tooltip top color="#FFF" max-width="350px" content-class="content-tooltip-transfer">
                  <template v-slot:activator="{ on,attrs }">
                    <div v-on="on" v-bind="attrs">
                    <span v-for="(program, key) in transferFeeDetail.newPackageInfo.programGroup" :key="program.id+ 'programGroup'" style="cursor: pointer; font-size: 14px !important;">
                      {{ program.id }} <span v-if="key < transferFeeDetail.newPackageInfo.programGroup.length -1 ">; </span>
                    </span>
                    </div>
                  </template>
                  <div  style="color: #000 !important;">
                    <div v-for="(program) in transferFeeDetail.newPackageInfo.programGroup"  :key="program.id+ 'programGroupName'">
                      {{ program.title }}
                      <br>
                    </div>
                  </div>
                </v-tooltip>
              </template>
            </strong>
          </div>
          <div class="mb-3">
            Loại chuyển :
            {{transferFeeDetail.typeTransfer ? checkEmptyData(transferFeeDetail.typeTransfer.name) : '' }}
            <span> - </span>
            {{transferFeeDetail.paymentMethod ? checkEmptyData(transferFeeDetail.paymentMethod.name) : '' }}
          </div>
          <div class="mb-3 d-flex">
            <div style="width: 100px">
              Gói nhận phí :
            </div>
            <template v-if="transferFeeDetail.paymentMethod.id === PAYMENT_METHOD.NGANG_TIEN">
              <div style="width: calc(100% - 108px)" v-if="transferFeeDetail.newPackageInfo.skuTutor && transferFeeDetail.newPackageInfo.skuTutor.name">
                1. {{ transferFeeDetail.newPackageInfo.skuTutor.name }}
                <!--                <div v-for="(pkg, index) in newPackages" :key="index" class="mb-3">-->
                <!--                  {{ index + 1 }}. {{ pkg.name }} (SL: {{ pkg.quantity }})-->
                <!--                </div>-->
              </div>
            </template>
            <div v-else-if="transferFeeDetail.newProducts && transferFeeDetail.newProducts.length > 0" style="width: calc(100% - 108px)" >
              <div v-for="(product, index) in transferFeeDetail.newProducts" :key="'product' + index">
                {{index + 1}}. {{ product.skuName }} ( SL: {{product.quantity}} )
                <!--                <div v-for="(pkg, index) in newPackages" :key="index" class="mb-3">-->
                <!--                  {{ index + 1 }}. {{ pkg.name }} (SL: {{ pkg.quantity }})-->
                <!--                </div>-->
              </div>
            </div>
          </div>
          <div class="mb-3 d-flex" v-if="transferFeeDetail.paymentMethod.id === PAYMENT_METHOD.THANH_TOAN_THEM">
            Đơn hàng thanh toán thêm: <div style="color: blue; margin-left: 4px;" class="font-weight-bold">{{transferFeeDetail.newOrderCode}}</div>
          </div>
          <div class="mb-3"  style="font-weight: 500; color: #3B00EB" v-if="transferFeeDetail.paymentMethod.id === PAYMENT_METHOD.NGANG_TIEN">
            SỐ LƯỢNG BUỔI TỐI ĐA SAU QUY ĐỔI : <span style="margin-left: 3px;padding:7px 10px; border-radius: 4px; border: 1px solid #3B00EB">
                {{ checkEmptyData(transferFeeDetail.newPackageInfo.numberTargetLesson)  }} BUỔI</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
const PAYMENT_METHOD = {
  NGANG_TIEN: 1,
  THANH_TOAN_THEM: 2,
}
import moment from "moment";
export default {
  name: 'TransferTicket',
  props: {
    urlERP: {
      type: String,
      default: process.env.VUE_APP_SORT_CLASS,
    },
    urlOMS: {
      type: String,
      default: process.env.VUE_APP_API_OMS,
    },
    urlCRM: {
      type: String,
      default: process.env.VUE_APP_API_ERP,
    },
    transferFeeDetail: {
      default: () => {},
    },
    isConfirm: {
      default: true,
    },
  },
  data() {
    return {
      moment,
      PAYMENT_METHOD,
      isShowDetailTransferFee: false,
    };
  },
  methods: {
    handleShowDetail() {
      this.$emit('showTransferDetail', this.transferFeeDetail._id)
      this.isShowDetailTransferFee = true;
    },
    checkEmptyData(data) {
      return data != null || data !== '' ? data : '';
    },
  },
};
</script>

<style scoped>
.ticket-card {
  border-radius: 12px !important;
}

.package-section {
  height: 100%;
  position: relative;
}

.transfer-divider {
  position: relative;
  height: 100%;
}

.circle-arrow {
  width: 28px;
  height: 28px;
  background-color: #6F44FF;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
}

.dashed-line {
  position: absolute;
  left: 46%;
  top: 31px;
  bottom: 0;
  border-left: 1px dashed #6F44FF;
  z-index: 1;
}

strong {
  font-weight: 600;
  color: #333;
}
.content-tooltip-transfer {
  box-shadow: 4px 4px 4px 0 rgba(102, 102, 102, 0.25);
  background: #fff !important;
}
</style>
